module.exports = __webpack_public_path__ + "img/bx-qapaper-setting.e824e9c2.svg";